import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Megaphone, X } from 'lucide-react';

/**
 * LatestUpdates — animated marquee-style announcement bar shown at the very top
 * of the homepage. Pulls items from a static list (could be made API-backed later
 * via /api/updates if the admin needs to edit it).
 *
 * Users can dismiss the banner; the choice is persisted to localStorage.
 */
const UPDATES = [
  '🏆 LAST DAY TO REGISTER FOR BEST DOG DAD AND HERO DOG PHOTO COMPETITION ENTRIES!',
  '📸 Free professional dog portraits on the day, courtesy of Emma Nayler Photography — bring your pup (and yourself if you like)!',
];

const STORAGE_KEY = 'twra_updates_banner_dismissed_v3';

const LatestUpdates = () => {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(localStorage.getItem(STORAGE_KEY) === '1');
  }, []);

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };

  // Duplicate the items so the marquee loop is seamless
  const items = [...UPDATES, ...UPDATES];

  return (
    <div className="relative bg-gradient-to-r from-cyan-600 via-teal-600 to-emerald-600 text-white shadow-md overflow-hidden" data-testid="latest-updates-banner">
      <div className="flex items-center max-w-7xl mx-auto">
        {/* Label */}
        <div className="hidden sm:flex flex-shrink-0 items-center gap-2 px-4 py-2.5 bg-black/15 font-semibold text-xs uppercase tracking-[0.18em]">
          <Megaphone className="h-4 w-4" />
          <span>Latest Updates</span>
        </div>

        {/* Marquee */}
        <div className="relative flex-1 overflow-hidden py-2.5">
          <div className="flex animate-marquee whitespace-nowrap">
            {items.map((text, idx) => (
              <span key={`${text}-${idx}`} className="mx-8 text-sm md:text-base font-medium">
                {text}
              </span>
            ))}
          </div>
        </div>

        {/* Link + dismiss */}
        <div className="flex items-center flex-shrink-0">
          <Link
            to="/contact"
            className="hidden md:inline-block text-xs font-semibold uppercase tracking-wider px-4 py-2.5 hover:bg-black/15 transition-colors border-l border-white/20"
            data-testid="latest-updates-link"
          >
            Get in touch →
          </Link>
          <button
            type="button"
            onClick={handleDismiss}
            aria-label="Dismiss updates banner"
            data-testid="dismiss-updates"
            className="p-2.5 hover:bg-black/15 transition-colors border-l border-white/20"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default LatestUpdates;
